import FilesToUploadGrid from './FilesToUploadGrid';

export default FilesToUploadGrid;
